/** Sensitive results live only in memory for the current authentication epoch. */
let generation = 0;
const entries = new Map<string, string>();
export const AUTH_EPOCH_KEY = "meridian.authEpoch";

export function authGeneration(): number {
  return generation;
}

export function clearPrivateData(broadcast = false): void {
  generation += 1;
  entries.clear();
  for (const kind of ["localStorage", "sessionStorage"] as const) {
    try {
      const storage = window[kind];
      const keys = Array.from({ length: storage.length }, (_, i) => storage.key(i));
      for (const key of keys) {
        // Remove legacy unpartitioned results and workspace pointers. Keep
        // language/theme preferences, which contain no tenant data.
        if (key && (key.startsWith("meridian.") || key.startsWith("home.renders:")) && ![AUTH_EPOCH_KEY, "meridian.locale", "meridian.theme"].includes(key)) {
          storage.removeItem(key);
        }
      }
    } catch {
      // Storage is optional; sensitive results never depend on it.
    }
  }
  if (broadcast) {
    try { window.localStorage.setItem(AUTH_EPOCH_KEY, crypto.randomUUID()); } catch { /* unavailable */ }
  }
}

export const privateDataCache = {
  getItem(key: string): string | null { return entries.get(key) ?? null; },
  setItem(key: string, value: string): void { entries.set(key, value); },
  removeItem(key: string): void { entries.delete(key); },
};
